import { AppUrlPath } from "@/lib/AppUrlPath";
import { useTenantStore } from "@/stores/tenantStore";
import { roleAllowed, useUserStore } from "@/stores/userStore";
import type { RoleType } from "@repo/types";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useRoleProtected = (minRole: RoleType) => {
  const { activeRole, id: userId } = useUserStore((s) => ({
    activeRole: s.activeRole,
    id: s.id,
  }));
  const { id: tenantId } = useTenantStore((s) => ({ id: s.id }));
  const navigate = useNavigate();

  useEffect(() => {
    if (!userId) {
      navigate("/auth/login");
    }
    if (!activeRole) return; // wait for page to finish loading

    if (!roleAllowed({ current: activeRole, required: minRole })) {
      navigate(new AppUrlPath(tenantId).tenantHomePath);
    }
  }, [activeRole, userId, tenantId, minRole, navigate]);
};
